module.exports = __webpack_public_path__ + "assets/webgl/LM_3_1.31543f76.jpg";